'use client';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { SquareSkeleton } from '../../SquareSkeleton';
import { SideBarBox } from '../SideBarBox';

type Props = {
  title: string;
};

export const RankingLoading: React.FC<Props> = ({ title }) => {
  return (
    <SideBarBox id="ranking" title={title}>
      {[...Array(5)].map((_, index) => (
        <Box key={`ranking-skelton-${index}`} p={1}>
          <Card elevation={0} sx={{ width: '100%' }}>
            <Grid container spacing={1}>
              <Grid size={{ xs: 4 }}>
                <SquareSkeleton />
              </Grid>
              <Grid size={{ xs: 8 }}>
                <Box>
                  <Skeleton variant="text" />
                  <Skeleton variant="text" />
                </Box>
              </Grid>
            </Grid>
          </Card>
        </Box>
      ))}
    </SideBarBox>
  );
};
